import React from "react";

const AccountSettings = (() => {
  return <div></div>;
}) as React.FC<{}>;

export default AccountSettings;
